// extracted by css-extract-rspack-plugin
export default {"tag":"tag-TwQuhF","tagContent":"tagContent-ElsH0O"};